module.exports = __webpack_public_path__ + "img/benin.b56def27.svg";